// Form validation and submission logic
(function() {
    'use strict';
    
    // Only run if form exists on the page
    if (!document.getElementById('form')) return;
    
    document.addEventListener("DOMContentLoaded", function () {
        const submitBtn = document.getElementById("submitBtn");
        const form = document.getElementById("form");
        
        if (submitBtn) submitBtn.disabled = false;

        // Check for #rep hashtag and auto-check contact_me checkbox
        if (window.location.hash === '#rep') {
            const contactMeCheckbox = document.querySelector('input[name="contact_me"]');
            if (contactMeCheckbox) {
                contactMeCheckbox.checked = true;
            }
        }

        // Function to update GTM label based on contact_me checkbox
        function updateGTMLabel() {
            const contactMeCheckbox = document.querySelector('input[name="contact_me"]');
            if (contactMeCheckbox && submitBtn) {
                if (contactMeCheckbox.checked) {
                    submitBtn.setAttribute('gtm-label', 'request-a-rep');
                } else {
                    submitBtn.setAttribute('gtm-label', 'sign-up');
                }
            }
        }

        // Initial GTM label update on page load
        updateGTMLabel();

        // Add event listener to contact_me checkbox to update GTM label when changed
        const contactMeCheckbox = document.querySelector('input[name="contact_me"]');
        if (contactMeCheckbox) {
            contactMeCheckbox.addEventListener('change', updateGTMLabel);
        }

        // Validation functions
        function validateName(name) {
            // Name should only contain letters, periods, spaces, apostrophes, hyphens, max 20 characters
            const nameRegex = /^[a-zA-Z\s\-'\.]{1,20}$/;
            return nameRegex.test(name) && name.trim().length > 0;
        }

        function validateZip(zip) {
            // ZIP code should be exactly 5 numbers
            const zipRegex = /^\d{5}$/;
            return zipRegex.test(zip);
        }

        function validatePhone(phone) {
            // Phone should be 1-10 numbers (if provided)
            if (!phone || phone.trim() === '') return true; // Phone is optional
            const phoneRegex = /^\d{1,10}$/;
            return phoneRegex.test(phone);
        }

        function validateNPI(npi) {
            // NPI should be exactly 10 numbers (if provided)
            if (!npi || npi.trim() === '') return true; // NPI is optional
            const npiRegex = /^\d{10}$/;
            return npiRegex.test(npi);
        }

        function validateEmail(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        }

        function showError(fieldId, message) {
            const errorElement = document.getElementById(fieldId + '_error');
            let inputElement = document.getElementById(fieldId);
            
            // If no element found by ID, try to find by name (for checkboxes)
            if (!inputElement) {
                inputElement = document.querySelector(`input[name="${fieldId}"]`);
            }
            
            if (errorElement) {
                errorElement.textContent = message;
                errorElement.style.display = 'block';
            }
            if (inputElement) {
                // Special handling for select elements inside custom-select
                if (inputElement.tagName === 'SELECT' && inputElement.closest('.custom-select')) {
                    inputElement.closest('.custom-select').classList.add('error');
                }
                // Special handling for checkboxes with custom styling
                else if (inputElement.type === 'checkbox') {
                    const customCheckbox = inputElement.nextElementSibling;
                    if (customCheckbox && customCheckbox.classList.contains('custom-checkbox')) {
                        customCheckbox.classList.add('error');
                    }
                    inputElement.classList.add('error');
                } else {
                    inputElement.classList.add('error');
                }
            }
        }

        function clearError(fieldId) {
            const errorElement = document.getElementById(fieldId + '_error');
            let inputElement = document.getElementById(fieldId);
            
            // If no element found by ID, try to find by name (for checkboxes)
            if (!inputElement) {
                inputElement = document.querySelector(`input[name="${fieldId}"]`);
            }
            
            if (errorElement) {
                errorElement.textContent = '';
                errorElement.style.display = 'none';
            }
            if (inputElement) {
                // Special handling for select elements inside custom-select
                if (inputElement.tagName === 'SELECT' && inputElement.closest('.custom-select')) {
                    inputElement.closest('.custom-select').classList.remove('error');
                }
                // Special handling for checkboxes with custom styling
                else if (inputElement.type === 'checkbox') {
                    const customCheckbox = inputElement.nextElementSibling;
                    if (customCheckbox && customCheckbox.classList.contains('custom-checkbox')) {
                        customCheckbox.classList.remove('error');
                    }
                    inputElement.classList.remove('error');
                } else {
                    inputElement.classList.remove('error');
                }
            }
        }

        function validateForm() {
            let isValid = true;

            // Clear all previous errors
            const baseErrorFields = ['first_name', 'last_name', 'email', 'zip', 'npi', 'specialty', 'privacy_agree', 'consent_agree'];
            const trainerErrorFields = ['trainer_prescriber_name','trainer_npi','trainer_contact','trainer_phone','trainer_address','trainer_city','trainer_state','trainer_zip'];
            const trainerChecked = document.querySelector('input[name=\"trainer_agree\"]')?.checked;
            const trainerVisible = document.querySelector('.trainer-details')?.classList.contains('is-visible');
            const trainerActive = !!(trainerChecked || trainerVisible);
            const errorFields = trainerActive ? baseErrorFields.concat(trainerErrorFields) : baseErrorFields;
            errorFields.forEach(field => clearError(field));

            // Validate first name
            const firstName = document.getElementById('first_name').value.trim();
            if (!firstName) {
                showError('first_name', 'This field is required.');
                isValid = false;
            } else if (!validateName(firstName)) {
                showError('first_name', 'First name must be maximum 20 characters and contain only letters, periods, spaces, apostrophes, and hyphens.');
                isValid = false;
            }

            // Validate last name
            const lastName = document.getElementById('last_name').value.trim();
            if (!lastName) {
                showError('last_name', 'This field is required.');
                isValid = false;
            } else if (!validateName(lastName)) {
                showError('last_name', 'Last name must be maximum 20 characters and contain only letters, periods, spaces, apostrophes, and hyphens.');
                isValid = false;
            }

            // Validate email
            const email = document.getElementById('email').value.trim();
            if (!email) {
                showError('email', 'This field is required.');
                isValid = false;
            } else if (!validateEmail(email)) {
                showError('email', 'Please enter a valid email address.');
                isValid = false;
            }

            // Validate ZIP code
            const zip = document.getElementById('zip').value.trim();
            if (!zip) {
                showError('zip', 'This field is required.');
                isValid = false;
            } else if (!validateZip(zip)) {
                showError('zip', 'ZIP code must be exactly 5 numbers.');
                isValid = false;
            }

            // Validate NPI (optional field)
            const npi = document.getElementById('npi').value.trim();
            if (npi && !validateNPI(npi)) {
                showError('npi', 'NPI must be exactly 10 digits.');
                isValid = false;
            }

            // Validate specialty
            const specialty = document.getElementById('specialty').value;
            if (!specialty) {
                showError('specialty', 'You must make a selection.');
                isValid = false;
            }

            // Validate Train the Trainer fields when checked
            if (trainerActive) {
                const tPrescriber = document.getElementById('trainer_prescriber_name').value.trim();
                if (!tPrescriber) {
                    showError('trainer_prescriber_name', 'This field is required.');
                    isValid = false;
                }
                const tNpi = document.getElementById('trainer_npi').value.trim();
                if (!tNpi) {
                    showError('trainer_npi', 'This field is required.');
                    isValid = false;
                } else if (!validateNPI(tNpi)) {
                    showError('trainer_npi', 'NPI number must be exactly 10 numbers.');
                    isValid = false;
                }
                const tContact = document.getElementById('trainer_contact').value.trim();
                if (!tContact) {
                    showError('trainer_contact', 'This field is required.');
                    isValid = false;
                }
                const tPhone = document.getElementById('trainer_phone').value.trim();
                if (!tPhone) {
                    showError('trainer_phone', 'This field is required.');
                    isValid = false;
                }
                const tAddress = document.getElementById('trainer_address').value.trim();
                if (!tAddress) {
                    showError('trainer_address', 'This field is required.');
                    isValid = false;
                }
                const tCity = document.getElementById('trainer_city').value.trim();
                if (!tCity) {
                    showError('trainer_city', 'This field is required.');
                    isValid = false;
                }
                const tState = document.getElementById('trainer_state').value;
                if (!tState) {
                    showError('trainer_state', 'You must make a selection.');
                    isValid = false;
                }
                const tZip = document.getElementById('trainer_zip').value.trim();
                if (!tZip) {
                    showError('trainer_zip', 'This field is required.');
                    isValid = false;
                } else if (!validateZip(tZip)) {
                    showError('trainer_zip', 'ZIP code must be exactly 5 numbers.');
                    isValid = false;
                }
            }

            // Validate privacy agreement
            const privacyAgree = document.querySelector('input[name="privacy_agree"]');
            if (!privacyAgree.checked) {
                showError('privacy_agree', 'You must certify that you are a US resident and 18 years or older to continue.');
                isValid = false;
            }

            // Validate consent agreement
            const consentAgree = document.querySelector('input[name="consent_agree"]');
            if (!consentAgree.checked) {
                showError('consent_agree', 'You must provide your consent to proceed.');
                isValid = false;
            }

            return isValid;
        }

        // Add real-time validation for specific fields
        document.getElementById('first_name').addEventListener('blur', function() {
            const value = this.value.trim();
            if (value && !validateName(value)) {
                showError('first_name', 'First name must be maximum 20 characters and contain only letters, periods, spaces, apostrophes, and hyphens.');
            } else {
                clearError('first_name');
            }
        });

        // Restrict first name input to letters, periods, spaces, apostrophes, hyphens and max 20 characters
        document.getElementById('first_name').addEventListener('input', function() {
            this.value = this.value.replace(/[^a-zA-Z\s\-'\.]/g, '').substring(0, 20);
        });

        document.getElementById('last_name').addEventListener('blur', function() {
            const value = this.value.trim();
            if (value && !validateName(value)) {
                showError('last_name', 'Last name must be maximum 20 characters and contain only letters, periods, spaces, apostrophes, and hyphens.');
            } else {
                clearError('last_name');
            }
        });

        // Restrict last name input to letters, periods, spaces, apostrophes, hyphens and max 20 characters
        document.getElementById('last_name').addEventListener('input', function() {
            this.value = this.value.replace(/[^a-zA-Z\s\-'\.]/g, '').substring(0, 20);
        });

        document.getElementById('zip').addEventListener('blur', function() {
            const value = this.value.trim();
            if (value && !validateZip(value)) {
                showError('zip', 'ZIP code must be exactly 5 numbers.');
            } else {
                clearError('zip');
            }
        });

        // Restrict ZIP code input to numbers only and max 5 digits
        document.getElementById('zip').addEventListener('input', function() {
            this.value = this.value.replace(/\D/g, '').substring(0, 5);
        });

        document.getElementById('npi').addEventListener('blur', function() {
            const value = this.value.trim();
            if (value && !validateNPI(value)) {
                showError('npi', 'NPI number must be exactly 10 numbers.');
            } else {
                clearError('npi');
            }
        });

        // Restrict NPI input to numbers only and max 10 digits
        document.getElementById('npi').addEventListener('input', function() {
            this.value = this.value.replace(/\D/g, '').substring(0, 10);
        });

        // Handle phone field if it exists
        const phoneElement = document.getElementById('phone_number');
        if (phoneElement) {
            phoneElement.addEventListener('blur', function() {
                const value = this.value.trim();
                if (value && !validatePhone(value)) {
                    showError('phone_number', 'Phone number must be maximum 10 digits.');
                } else {
                    clearError('phone_number');
                }
            });

            // Restrict phone input to numbers only and max 10 digits
            phoneElement.addEventListener('input', function() {
                this.value = this.value.replace(/\D/g, '').substring(0, 10);
            });
        }

            // Trainer numeric helpers
            const trainerZipEl = document.getElementById('trainer_zip');
            if (trainerZipEl) {
                trainerZipEl.addEventListener('input', function() {
                    this.value = this.value.replace(/\D/g, '').substring(0, 5);
                });
            }
            const trainerNpiEl = document.getElementById('trainer_npi');
            if (trainerNpiEl) {
                trainerNpiEl.addEventListener('input', function() {
                    this.value = this.value.replace(/\D/g, '').substring(0, 10);
                });
            }

        // Function to show thank you message
        function showThankYouMessage() {
            const stayConnectedSection = document.getElementById('stay-connected');
            if (stayConnectedSection) {
                // Update the existing section content instead of replacing HTML
                const sectionHeader = stayConnectedSection.querySelector('.section-header h2');
                const sectionDescription = stayConnectedSection.querySelector('.section-header p');
                const formElement = stayConnectedSection.querySelector('.signup-form');
                
                if (sectionHeader) {
                    sectionHeader.textContent = "Thank you for registering";
                }
                
                if (sectionDescription) {
                    sectionDescription.textContent = "We will send you occasional email updates regarding YUVIWEL.";
                }
                
                if (formElement) {
                    formElement.style.display = "none";
                }
                
                // Scroll to the thank you message with header offset
                setTimeout(() => {
                    const header = document.querySelector('header') || document.querySelector('.header');
                    const headerHeight = header ? header.offsetHeight : 80; // fallback to 80px if header not found
                    const elementPosition = stayConnectedSection.getBoundingClientRect().top + window.pageYOffset;
                    const offsetPosition = elementPosition - headerHeight - 20; // extra 20px padding
                    
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }, 100); // Small delay to ensure content is rendered
                
                // Trigger GTM event if available
                if (typeof gtag !== 'undefined') {
                    const contactMeCheckbox = document.querySelector('input[name="contact_me"]');
                    const eventLabel = contactMeCheckbox && contactMeCheckbox.checked ? 'request-a-rep' : 'sign-up';
                    gtag('event', 'form_submit_success', {
                        'event_category': 'engagement',
                        'event_label': eventLabel
                    });
                }
                
                // Clear any hash from URL
                if (window.location.hash) {
                    history.replaceState(null, null, window.location.pathname + window.location.search);
                }
            }
        }

        // Flag to prevent showing success message multiple times
        let successMessageShown = false;

        // Handle form submission with iframe approach
        function submitFormWithIframe(token) {
            // Set reCAPTCHA token
            document.getElementById("recaptchaToken").value = token;
            
            // Get the hidden iframe
            const hiddenIframe = document.getElementById("hidden-form-target");
            
            // Disable submit button during submission
            submitBtn.disabled = true;
            submitBtn.classList.add('submitting');
            submitBtn.innerHTML = 'Submitting...';
            
            // Listen for iframe load event to detect when form submission completes
            if (hiddenIframe) {
                hiddenIframe.addEventListener("load", function() {
                    // Show success message after form submission
                    if (!successMessageShown) {
                        successMessageShown = true;
                        showThankYouMessage();
                    }
                }, { once: true });
            }
            
            // Submit the form (it will submit to the hidden iframe)
            form.submit();
            
            // Fallback: Show success message after a short delay
            // This handles cases where the iframe load event doesn't fire
            setTimeout(function() {
                if (!successMessageShown) {
                    successMessageShown = true;
                    showThankYouMessage();
                }
            }, 1000);
        }

        // Handle form submission
        submitBtn.addEventListener("click", function (e) {
            e.preventDefault();
            
            if (this.disabled) return;

            if (!form) return;

            // Validate form before submission
            if (!validateForm()) {
                return;
            }

            // If validation passes, proceed with reCAPTCHA
            grecaptcha.ready(function () {
                grecaptcha.execute("6Lf3aOQrAAAAAEMCQre0Z3dbqdEOClxSy9PKpGNV", { action: "submit" })
                    .then(function (token) {
                        submitFormWithIframe(token);
                    })
                    .catch(function (error) {
                        console.error("reCAPTCHA execution failed:", error);
                        alert("CAPTCHA verification failed. Please try again.");
                    });
            });
        });
    });
})();
